import { mobileWindowWidth } from 'utils/hooks/useMobileVersion';
import useWindowSize from 'utils/hooks/useWindowSize';

export const useIsDesktop = () => {
  const { width } = useWindowSize();
  return width && width > mobileWindowWidth;
};
